var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 106,
    viewBox: "0 0 105 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_152)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.208 59.1592C107.976 30.5047 87.8007 4.22162 59.1463 0.454275C30.4918 -3.31307 4.20872 16.8619 0.441376 45.5164C-3.32597 74.1709 16.849 100.454 45.5035 104.221C74.158 107.989 100.441 87.8136 104.208 59.1592Z",
    fill: "#0061A3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_702_152",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.208 59.1592C107.976 30.5047 87.8007 4.22162 59.1463 0.454275C30.4918 -3.31307 4.20872 16.8619 0.441376 45.5164C-3.32597 74.1709 16.849 100.454 45.5035 104.221C74.158 107.989 100.441 87.8136 104.208 59.1592Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_702_152)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.12 68.4399H44.08V81.9399H64.12V68.4399Z",
    fill: "#F9C2A7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.95 78.2097C51.97 79.4097 55.28 80.1297 58.53 80.1597C60.39 80.1797 62.29 79.9397 64.13 79.6197V68.4497H44.09V75.4297C45.5 76.6697 47.29 77.5497 48.95 78.2097Z",
    fill: "#EDEDED"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8 43.03C75.87 42.53 76.71 41.72 77.08 41.45C77.9 40.84 78.73 41.47 78.97 42.26C79.18 42.97 79.2 43.77 79.26 44.5C79.38 46.29 79.11 48.05 78.31 49.67C77.77 50.75 76.93 51.64 75.93 52.31C75.93 52.31 74.85 52.85 74.64 51.61L75.81 43.03H75.8Z",
    fill: "#F9C2A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.63 44.11C75.68 43.75 76.28 43.1799 76.55 42.9799C77.14 42.5499 77.73 42.99 77.9 43.56C78.05 44.07 78.07 44.64 78.1 45.16C78.19 46.4399 78 47.7 77.42 48.86C77.03 49.63 76.43 50.27 75.71 50.75C75.71 50.75 74.94 51.13 74.79 50.25L75.63 44.11Z",
    fill: "#E1B099"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 43.03C31.83 42.53 30.99 41.72 30.62 41.45C29.8 40.84 28.97 41.47 28.73 42.26C28.52 42.97 28.5 43.77 28.44 44.5C28.31 46.29 28.59 48.05 29.39 49.67C29.93 50.75 30.77 51.64 31.77 52.31C31.77 52.31 32.85 52.85 33.06 51.61L31.89 43.03H31.9Z",
    fill: "#F9C2A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.07 44.11C32.02 43.75 31.42 43.1799 31.15 42.9799C30.56 42.5499 29.97 42.99 29.8 43.56C29.65 44.07 29.63 44.64 29.6 45.16C29.51 46.4399 29.7 47.7 30.28 48.86C30.67 49.63 31.27 50.27 31.99 50.75C31.99 50.75 32.76 51.13 32.91 50.25L32.07 44.11Z",
    fill: "#E1B099"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.46 44.6501C76.46 50.3101 75.48 56.0301 72.82 60.9201C70.49 65.2001 66.99 68.6301 63.23 71.3701C60.18 73.5901 56.91 76.1801 53.06 75.8601C49.04 75.5301 45.91 72.1001 42.97 69.4301C38.84 65.6701 35.58 61.0001 33.57 55.5001C32.33 52.1101 31.76 48.2901 31.76 44.6401C31.76 26.3501 41.77 14.8501 54.11 14.8501C66.45 14.8501 76.46 26.3501 76.46 44.6401V44.6501Z",
    fill: "#F9C2A7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1 88.05L64.12 81.52H44.08L19.1 88.05C19.1 88.05 7.52999 92.34 6.23999 105.91H101.96C100.67 92.34 89.1 88.05 89.1 88.05Z",
    fill: "#F9C2A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1 88.05L64.12 81.52H44.08L19.1 88.05C19.1 88.05 7.52999 92.34 6.23999 105.91H101.96C100.67 92.34 89.1 88.05 89.1 88.05Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.77 23.5999C37.77 23.5999 45.27 34.7499 64.13 36.0399C64.13 36.0399 62.55 35.3299 60.69 30.4699C60.69 30.4699 66.84 35.7599 74.63 39.1899L76.42 42.8199C76.42 42.8199 76.41 40.9699 78.12 41.2899C78.12 41.2899 79.55 26.7599 73.55 19.6099C73.55 19.6099 76.42 19.7499 78.27 21.3299C78.27 21.3299 75.55 15.6099 66.26 12.4699C66.26 12.4699 68.55 10.6099 72.69 11.8999C72.69 11.8999 67.21 9.32994 58.02 9.75994C58.02 9.75994 40 9.03994 37.77 23.6199V23.5999Z",
    fill: "#432918"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.69 26.25L31.8 42.73C31.8 42.73 31.01 41.78 30.63 41.45C30.63 41.45 30.17 18.81 42.71 14.52L40.7 26.24L40.69 26.25Z",
    fill: "#432918"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1 88.0502L70.62 83.2202L54.11 105.92L37.77 83.1802L19.11 88.0602C19.11 88.0602 7.54 92.3502 6.25 105.92H101.97C100.68 92.3502 89.11 88.0602 89.11 88.0602L89.1 88.0502Z",
    fill: "#3C3C3B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.91 94.54L47.31 105.91H60.39L55.9 94.54H51.91Z",
    fill: "#BC1621"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8 81.7397L47.95 89.5997L52.02 94.5697L54.01 94.5397L56.01 94.4997L59.91 89.3997L53.8 81.7397Z",
    fill: "#BE1622"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.72 88.5698C56.97 90.0498 55.58 91.7398 53.68 91.3198C51.72 90.8898 50.83 89.0398 51.28 87.1598C51.72 85.3298 52.9 83.7998 53.56 82.0698L47.94 89.5998L52.01 94.5698L56 94.5098L59.91 89.4098L58.26 87.3398C58.1 87.7598 57.92 88.1798 57.72 88.5798V88.5698Z",
    fill: "#DADADA"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.11 105.91L37.77 83.1699L24.71 86.5799L41.4 98.3299L37.11 100.22L44.83 105.91H54.11Z",
    fill: "#313130"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.11 105.94L70.44 83.1997L83.5 86.6097L66.81 98.3597L71.1 100.26L63.38 105.94H54.11Z",
    fill: "#313130"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 81.9899L44.05 77.3999L54.04 81.5699L64.02 77.3999L74.49 81.9899L59.69 91.8999L54.04 83.7999L47.95 91.8999L34.25 81.9899Z",
    fill: "#E9E9E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.67,
    height: 105.94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActor2);
export default __webpack_public_path__ + "static/media/actor2.c915fc1e6b662c9dc7c0c5e3cd1d374e.svg";
export { ForwardRef as ReactComponent };